export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14488.565f09f5.jpg";